<template>
	<TheHeader />
	<main>
		<theKV />
		<TheProduct />
		<SkinType />
		<TheSkin />
		<FreeTrial />
		<TheAwards />
		<GetSamples />
		<CheckIn />
	</main>
	<TheFooter />
	<Transition>
		<AwardList v-if="showDialog" @is-show="closeDialog($event)" />
    </Transition>
</template>

<script setup>
import TheHeader from '@/components/TheHeader.vue';
import theKV from '@/components/TheKV.vue';
import TheProduct from '@/components/TheProduct.vue';
import SkinType from '@/components/SkinType.vue';
import TheSkin from '@/components/TheSkin.vue';
import FreeTrial from '@/components/FreeTrial.vue';
import TheAwards from '@/components/TheAwards.vue';
import GetSamples from '@/components/GetSamples.vue';
import TheFooter from '@/components/TheFooter.vue';

import { defineAsyncComponent, ref } from 'vue';

const CheckIn = defineAsyncComponent(() => import('@/components/CheckIn.vue'));
const AwardList = defineAsyncComponent(() => import('@/components/widget/AwardList.vue'));

const showDialog = ref(true);
const closeDialog = close => showDialog.value = close;

</script>

<style lang="scss">
@import '@/styles/main.scss';

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
